module.exports = __webpack_public_path__ + "static/media/vehicle-extra-process.a432565b.svg";